module.exports = __webpack_public_path__ + "img/ic-analysis-lineplot2.65d55ff8.svg";